import { BadImplementationException, compare } from '@nu-art/ts-common';
import { AllowedOperators, defaultFallback, EvaluationLogicTypes } from '../consts.js';
import { valueID_No, valueID_Yes } from '../../../../_entity.js';
import { LogicType_IsFalse, LogicType_IsTrue } from '../../../../_enum.js';
import { createHVValueOption } from '../utils.js';
const defaultElseValue = 0;
// Evaluation Logic Types that cannot be used in a conversion
const unacceptableConversionEvaluationLogics = [
    EvaluationLogicTypes.self,
    EvaluationLogicTypes.exists,
    EvaluationLogicTypes.notExists,
];
export const getReturnValueType = (value) => {
    if (!value)
        throw new BadImplementationException('Missing value in case!');
    return value[0] === value[1] ? 'number' : 'tuple';
};
const validateConversionAtomCases = (dbAtom, conversionType) => {
    if (unacceptableConversionEvaluationLogics.includes(conversionType))
        throw new BadImplementationException(`The "${conversionType}" evaluation logic cannot be used with multiple cases!`);
    const conversionOutputType = getReturnValueType(dbAtom.cases[0].value);
    for (const _case of dbAtom.cases) {
        // Validate that all case output types are the same
        if (getReturnValueType(_case.value) !== conversionOutputType)
            throw new BadImplementationException('All cases must have the same output type!');
        // Validate all operators are compatible
        if (!AllowedOperators[conversionType].includes(_case.caseOperator))
            throw new BadImplementationException('Atom has different cases with incompatible operators');
    }
    // Validate fallback output type - fallback value of [0,0] can fit both outputTypes
    if ((dbAtom.fallbackValue && getReturnValueType(dbAtom.fallbackValue) !== conversionOutputType && !compare(dbAtom.fallbackValue, defaultFallback)) && !compare(dbAtom.fallbackValue, defaultFallback))
        throw new BadImplementationException('All cases must have the same output type!');
};
export const resolveConversionBaseEvaluationLogic = (dbAtom, conversionType) => {
    const evaluationLogic = {};
    validateConversionAtomCases(dbAtom, conversionType);
    evaluationLogic.output_type = getReturnValueType(dbAtom.cases[0].value);
    if (!dbAtom.fallbackValue)
        evaluationLogic.else_value = defaultElseValue;
    else
        evaluationLogic.else_value = evaluationLogic.output_type === 'tuple' ? dbAtom.fallbackValue : dbAtom.fallbackValue[0];
    return evaluationLogic;
};
export const resolveValuesSet = (_case, dependencies) => {
    // Specific cases explanation: in subTerms boolean atoms use the isFalse and IsTrue logic operators and doesn't have a right
    // hand value. so we explicitly taking care of that. this is fine and generic enough considering sub terms can't use conversion
    // only single case
    // In subTerm usage of is true equals to the calculation of equals to yes
    if (_case.caseOperator === LogicType_IsTrue)
        return [createHVValueOption(valueID_Yes, dependencies)];
    // In subTerm usage of is false equals to the calculation of equals to no
    if (_case.caseOperator === LogicType_IsFalse)
        return [createHVValueOption(valueID_No, dependencies)];
    return _case.rightHand?.map(id => createHVValueOption(id, dependencies));
};
//# sourceMappingURL=generic-conversion.js.map